















































import Vue from 'vue'
import gql from 'graphql-tag'
import XButton from '@/components/atoms/Button/XButton.vue'
import XCard from '@/components/atoms/Card/XCard.vue'

type Data = {
  partnerId: string
}

type Methods = {
  handleClick: () => void
}

export default Vue.extend<Data, Methods, {}, {}>({
  name: 'PartnerInfo',
  components: { XButton, XCard },
  data() {
    return {
      partnerId: this.$route.params.partnerId,
    }
  },
  methods: {
    handleClick() {
      this.$router.push({ name: 'Partner' })
    },
  },
  apollo: {
    myPartner: {
      query: gql`
        query myPartner($partnerId: ID!) {
          myPartner(partnerId: $partnerId) {
            partnerId
            name
            partnerCode
          }
        }
      `,
      variables(this: { partnerId: string }) {
        return {
          partnerId: this.partnerId,
        }
      },
    },
  },
})
